import { memo } from 'react';

import { LegalClientsListItemData } from 'api/types/data';
import {
  TableSortProps,
  Table,
  TablePaginationProps,
  TableOnCellClick,
  TableSetRowHref,
} from 'libs/ui';

import { ClientsListItem, SortField } from '../../types';

import { useLegalClientsTable } from './useLegalClientsTable';

export interface LegalClientsTableProps
  extends TableSortProps<SortField>,
    TablePaginationProps {
  clients: LegalClientsListItemData[];
  loading?: boolean;
  noRowsLabel?: string;
  onCellClick?: TableOnCellClick<ClientsListItem>;
  setRowHref?: TableSetRowHref<ClientsListItem>;
}

export const LegalClientsTable = memo(
  ({
    clients,
    loading,
    sort,
    limit,
    rowCount,
    page,
    noRowsLabel,
    onCellClick,
    onSortChange,
    setRowHref,
    onPaginationChange,
  }: LegalClientsTableProps) => {
    const { rows, columns } = useLegalClientsTable(clients);

    return (
      <Table
        columns={columns}
        limit={limit}
        loading={loading}
        noRowsLabel={noRowsLabel}
        page={page}
        rowCount={rowCount}
        rowHeight={60}
        rows={rows}
        setRowHref={setRowHref}
        sort={sort}
        onCellClick={onCellClick}
        onPaginationChange={onPaginationChange}
        onSortChange={onSortChange}
      />
    );
  }
);
